<template>
  <span>
<!--    &lt;!&ndash;    <span v-if="content.pinned">Pinned post</span>&ndash;&gt;
    <img v-if="!isAvatarMissing"
         :src="imageURL"
         class="profile-image" @error="imageLoadError"
         @click="customRequestEvent()">
    <img v-else src="@/assets/images/default_user.png" class="profile-image"
         @click="customRequestEvent()">-->
    <img v-if="!isAvatarMissing"
         @click="$emit('avatarClicked')"
         @error="imageLoadError"
      class="rounded-circle" :style="{ width: size || '50px', height: size || '50px', objectFit: 'cover' }" :src="imageURL" alt="">
     <img v-else @click="$emit('avatarClicked')"
          class="rounded-circle" :style="{ width: size || '50px', height: size || '50px', objectFit: 'cover' }"
          src="@/assets/images/stella/no_avatar.png" alt="">
  </span>
</template>

<script>

import {httpMixin} from "@/mixin/http-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {mapActions, mapGetters} from "vuex";

const missingAvatarCache = new Set();

export default {
  props: ['userId', 'size'],
  name: "MessageAvatar",
  mixins: [httpMixin],
  data() {
    return {
      imageURL: '',
      isAvatarMissing: this.userId ? missingAvatarCache.has(this.userId) : false
    }
  },
  created() {
    if (!this.isAvatarMissing && this.userId) {
      this.getCdnBaseUrl();
    }
  },
  computed: {
    ...mapGetters(['cdnBaseUrl'])
  },
  watch: {
    userId: {
      handler(newId) {
        if (!newId || missingAvatarCache.has(newId)) {
          this.isAvatarMissing = true;
          this.imageURL = '';
        } else {
          this.isAvatarMissing = false;
          this.getCdnBaseUrl();
        }
      }
    },
  },
  methods: {
    ...mapActions(['setCdnBaseUrl']),
    getCdnBaseUrl() {
      if (!this.userId || missingAvatarCache.has(this.userId)) {
        this.isAvatarMissing = true;
        return;
      }
      if (!this.cdnBaseUrl) {
        let url = `${SERVICE_CONTENT}/api/v1/public/cdn/base-url`;
        this.getData(url, (cndBaseUrl) => {
          this.setCdnBaseUrl(cndBaseUrl);
          this.setUpImageUrl();
        });
      } else {
        this.setUpImageUrl();
      }
    },
    setUpImageUrl() {
      if (!this.userId || missingAvatarCache.has(this.userId)) {
        this.isAvatarMissing = true;
        return;
      }
      this.imageURL = `${this.cdnBaseUrl}user-data/PUBLIC/${this.userId}/PROFILE/dp_50X50.jpg`;
    },
    imageLoadError(event) {
      if (this.userId) {
        missingAvatarCache.add(this.userId);
      }
      this.isAvatarMissing = true;
    },
  }
}
</script>


